module.exports = __webpack_public_path__ + "static/media/SDCVal.eef7fb28.jpg";